import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckConfigTypes } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { rolesFormatted } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMConfigTypesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CONFIG_TYPES } from '@constants/queryKeys';

interface IUseConsistencyCheckConfigTypesReturnType {
	configTypeOptions: TSelectOption[];
	isLoadingConfigTypeOptions: boolean;
}

type TUseConsistencyCheckConfigTypes = Partial<TCMConfigTypesDTO> & ICMMavenirVendor;

const useQueryConsistencyCheckConfigTypes = (
	params: TUseConsistencyCheckConfigTypes,
): IUseConsistencyCheckConfigTypesReturnType => {
	const {
		vendor,
		nodes,
		version,
		isMavenirVendor,
	} = params;

	const {
		data: configTypeOptions,
		isLoading: isLoadingConfigTypeOptions,
		isFetching: isFetchingConfigTypeOptions,
	} = useQuery<TNameTitle[], TSelectOption[]>({
		queryKey: [
			CONSISTENCY_CONFIG_TYPES,
			{
				nodes,
				vendor,
				version,
			},
			isMavenirVendor,
		],
		queryFn: extractQueryParams(getConsistencyCheckConfigTypes),
		select: (options) => rolesFormatted(options),
		enabled: [vendor, nodes, version, isMavenirVendor],
		...refetchOptions,
	});

	return {
		configTypeOptions: configTypeOptions || [],
		isLoadingConfigTypeOptions: (isLoadingConfigTypeOptions && !!configTypeOptions)
			|| isFetchingConfigTypeOptions,
	};
};

export default useQueryConsistencyCheckConfigTypes;
